export default "__VITE_ASSET__Bg$9s0cd__"